/// <amd-module name="Reporting/CFDReport/Pickers/BoardsQuery" />
import { Board, BoardsQuery } from "Analytics/Boards/CumulativeFlowDiagramQueries/BoardsQuery";
import { ICacheableQueryService } from "Dashboards/WidgetCommon/DashboardsCacheableQueryService";
import { IVssPageContext } from "VSS/Platform/Context";
export { Board };
import { reportCommand } from "Widgets/CumulativeFlowDiagram/QueryUtilities";

export async function getBoard(
    pageContext: IVssPageContext,
    projectId: string,
    teamId: string,
    boardCategoryReferenceName: string
): Promise<Board | undefined> {
    const queryCache = pageContext.getService<ICacheableQueryService>("IDashboardsCacheableQueryService");
    const query = new BoardsQuery(reportCommand, projectId, teamId);
    const result = await queryCache.getCacheableQueryResult(query);

    const matchingBoard = result.findIndex(board => {
        return board.BoardCategoryReferenceName === boardCategoryReferenceName;
    });
    return matchingBoard >= 0 ? result[matchingBoard] : undefined;
}
